<template>
  <div id="app" class="order">
    <div class="header border-1px">
      <div class="title">
        <span class="title-name">交易记录</span>
      </div>
    </div>
    <div class="tab border-1px">
      <div class="tab-item">
        <router-link to="/into" replace>转入</router-link>
      </div>
      <div class="tab-item">
        <router-link to="/out" replace>转出</router-link>
      </div>
      <div class="tab-item">
        <router-link to="/income" replace>收益</router-link>
      </div>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus">
  @import 'normalize.css/normalize.css'
  @import './style/app.styl'
  .order
    .header
      height 30px
      padding 10px 0
      // overflow hidden
      text-align center
      border-1px($color-gray-l)
      .title
        display inline-block
        height 30px
        line-height 30px
    .tab
      display flex
      width 100%
      height 42px
      line-height 40px
      // border-1px(#eee)
      .tab-item
        flex 1
        text-align center
        &>a
          display block
          text-decoration none
          color #333
          &.router-link-active
            color $color-green
            border-bottom 2px $color-green solid
</style>



// WEBPACK FOOTER //
// src/App.vue